module.exports = __webpack_public_path__ + "static/media/4.380f23a6.png";